import {
  AbstractFilterWidget,
  AbstractFilterWidgetValueTrigger
} from './_private/AbstractFilterWidget';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertCircle } from 'lucide-react';
import { ComponentProps } from 'react';
import { SimpleTooltip } from 'v5/design-system/Tooltip';

export interface UnsupportedFilterWidgetProps
  extends Omit<ComponentProps<'div'>, 'onRemove'> {
  filterField?: string;
  filterName?: React.ReactNode;
  filterIcon?: React.ReactNode;
  value?: unknown;
  onRemove: () => void;
}

const UnsupportedFilterWidgetInner = (
  {
    filterName,
    filterIcon,
    onRemove,
    filterField,
    value,
    ...rest
  }: UnsupportedFilterWidgetProps,
  ref: React.Ref<HTMLDivElement>
) => {
  const { t } = useTranslation('patterns');
  const valueString = value !== undefined ? JSON.stringify(value, null, 2) : '';

  return (
    <AbstractFilterWidget
      ref={ref}
      filterName={filterName || filterField || 'Unknown Filter'}
      filterIcon={filterIcon || <AlertCircle className="size-4" />}
      onRemove={onRemove}
      filterField={filterField}
      {...rest}
      operatorSlot={null}
      valueSlot={
        <SimpleTooltip
          title={valueString || t('FilterWidget.unsupported', 'Unsupported')}
        >
          <AbstractFilterWidgetValueTrigger
            aria-readonly
            className="cursor-default text-muted-foreground"
            data-element="value-trigger"
          >
            {t('FilterWidget.unsupported', 'Unsupported')}
          </AbstractFilterWidgetValueTrigger>
        </SimpleTooltip>
      }
    />
  );
};

export const UnsupportedFilterWidget = forwardRef<
  HTMLDivElement,
  UnsupportedFilterWidgetProps
>(UnsupportedFilterWidgetInner);
